export enum AxionCardReservoir {
  BIBLIOTECA_GENERAL = 'AXIONCARD_BIBLIOTECA',
  CONVENIOS = 'AXIONCARD_PSS_CONVENIOS',
  ZONAS = 'AXIONCARD_PSS_ZONAS',
  DESTINATARIOS = 'AXIONCARD_PSS_DESTINATARIOS',
  AXIONCARD_PSS = 'AXIONCARD_PSS',
}
